import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { emitOpenLoginDialog } from '@/plugins/emitter'
import { useReferralOfferVisibility } from '@/composables/yagiprime/useReferralOfferVisibility'
import campaign from '@/utils/yagiprime/referralCampaign.json'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferralCampaignBanner',
  props: {
    placement: null,
    newTab: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { placement: string, newTab: boolean };

/**
 * ヤギプライム紹介割引キャンペーンの告知バナー。
 *
 * ヤギプライムへ遷移するボタン（志望動機・証明写真・確認画面の
 * ポップアップ）の近くに置き、「紹介すればお互い30日無料」を知らせる。
 * 押すとマイページ＞ヤギプライムのシェア枠へ行く。未ログインはマイページに
 * 入れない（requiresAuth で /login へ飛ばされ、編集中の画面から離れる）ので
 * ログインダイアログを開く。
 * 出し分けはシェア枠と同じ条件（useReferralOfferVisibility）。
 */


const copy = campaign.banner

const { isAuthenticated, showCampaignOffer } = useReferralOfferVisibility()

const linkAttrs = computed(() => {
  if (!isAuthenticated.value) return { type: 'button' }
  return props.newTab
    ? { href: copy.path, target: '_blank', rel: 'noopener' }
    : { href: copy.path }
})

function onClick(): void {
  if (isAuthenticated.value) return
  emitOpenLoginDialog()
}

return { __sfc: true,props, copy, isAuthenticated, showCampaignOffer, linkAttrs, onClick }
}

})